/* ==================================================================
   PREDOGLED LASERSKE GRAVURE  —  Body&Mind
   ------------------------------------------------------------------
   Predogled samo POSLUŠA polja aplikacije EasyFlow Product Options.
   Vanje ne piše in jih ne nadomešča. Naročilo teče izključno skozi
   EasyFlow — če ta spremeni svojo kodo, predogled samo neha risati,
   naročila pa delujejo naprej.

   Edina izjema: gumbi s primeri imen. Ti v polje EasyFlow pišejo,
   ker je to edini način, da obiskovalca pripeljejo do predogleda
   brez tipkanja. Preizkus, ki odloči, ali ostanejo: klik na gumb,
   dodaj v košarico, v košarici mora pisati vpisano ime.

   21. 10. 2026: PNG kaže, kar laser res zapeče (ozadje odstranjeno),
   mere in decimalno ločilo po jeziku, na telefonu predogled nad poljem.
   ================================================================== */
(function () {
  'use strict';

  /* ================================================================
     1) POLJA EASYFLOW  —  edino mesto, kjer so imena polj
     ----------------------------------------------------------------
     Če EasyFlow polja preimenuje, popraviš samo to konstanto.
     ================================================================ */
  var EASYFLOW = {
    /* vsebnik, v katerem EasyFlow nariše vsa polja */
    rootSelector: '.ef__product-option-root',

    /* polje za ime — atribut name */
    nameFieldName: 'Type your Name',

    /* spustni seznam za pisavo.
       Seznam nima ne imena ne id-ja, zato ga prepoznamo po vrednostih
       (glej fontValues). Oznaka spodaj je samo rezervna pot.          */
    fontFieldLabel: 'Engraving font',

    /* polje za nalaganje datoteke — atribut name */
    fileFieldName: 'Upload your own design for rings (PNG)',

    /* privzeta vrednost spustnega seznama */
    fontDefault: 'Great Vibes',

    /* leva stran = vrednost v seznamu EasyFlow (velike črke in
       presledki morajo biti točni), desna = pisava v predogledu      */
    fontValues: {
      'Great Vibes':      'great-vibes',
      'Alex Brush':       'alex-brush',
      'Arimo Bold':       'arimo-bold',
      'Alegreya SC Bold': 'alegreya',
      'Bebas Neue':       'bebas',
      'Oswald SemiBold':  'oswald'
    },

    /* kako dolgo čakamo, da EasyFlow nariše polja (ms) */
    waitMs: 15000
  };

  /* ================================================================
     2) PISAVE
     ----------------------------------------------------------------
     Velikosti tu NISO vpisane. Izračunajo se same, za vse pisave po
     istem pravilu: velika črka H mora biti visoka capHeightMm.
     ================================================================ */
  var FONTS = [
    { id: 'great-vibes', family: 'Great Vibes', weight: 400, label: 'Great Vibes' },
    { id: 'alex-brush',  family: 'Alex Brush',  weight: 400, label: 'Alex Brush' },
    { id: 'arimo-bold',  family: 'Arimo',       weight: 700, label: 'Arimo Bold' },
    { id: 'alegreya',    family: 'Alegreya SC', weight: 700, label: 'Alegreya SC Bold' },
    { id: 'bebas',       family: 'Bebas Neue',  weight: 400, label: 'Bebas Neue' },
    { id: 'oswald',      family: 'Oswald',      weight: 600, label: 'Oswald SemiBold' }
  ];

  var CFG = window.EngravingPreviewConfig;
  if (!CFG) return;

  var DEBUG = /[?&]debug=1(&|$)/.test(window.location.search);

  /* ================================================================
     3) IZPELJANE MERE
     ================================================================ */
  var pxPerMm = 0, pxToPt = 0;
  var GEO = { cx: 0, cy: 0, r: 0, outerR: 0, w: 0, h: 0 };

  var TAU = Math.PI / 180;
  function toDeg(rad) { return rad / TAU; }
  function toRad(deg) { return deg * TAU; }
  function mm(px) { return px / pxPerMm; }
  function fmt(v) { var s = v.toFixed(1); return (CFG && CFG.decimal === '.') ? s : s.replace('.', ','); }

  function computeGeometry(w, h) {
    GEO.w = w;
    GEO.h = h;
    GEO.outerR = w * CFG.ringOuterRadiusPct / 100;
    GEO.cx = w * CFG.arcCenterXPct / 100;
    GEO.cy = h * CFG.arcCenterYPct / 100;
    GEO.r  = w * CFG.arcRadiusPct  / 100;

    pxPerMm = (2 * GEO.outerR) / CFG.ringOuterDiameterMm;
    /* Ker se pxPerMm in pxToPt spreminjata skupaj, so mere v mm in pt
       neodvisne od velikosti fotografije. To je ves smisel odstotkov. */
    pxToPt = pxPerMm * 25.4 / 72;
  }

  /* ================================================================
     4) VELIKOSTI PISAV  —  ena metoda za vse
     ----------------------------------------------------------------
     Črko H narišemo in preštejemo piksle od osnovne črte NAVZGOR.
     Pri skript pisavah gre H tudi pod osnovno črto, zato bi celoten
     obris dal previsoko številko. Merimo pri 1000 px, ker brskalnik
     zaokroža na cele piksle in bi pri 100 px nastalo do 1 % napake.
     Prag 128 je sredina mehkega roba, torej pravi rob obrisa.
     ================================================================ */
  var MEASURE_SIZE = 1000;
  var sizesReady = false;

  function measureCapPx(f, sizePx) {
    var w = Math.ceil(sizePx * 1.4);
    var baseY = Math.round(sizePx * 1.5);
    var c = document.createElement('canvas');
    c.width = w;
    c.height = Math.ceil(sizePx * 1.8);
    var g = c.getContext('2d', { willReadFrequently: true });
    g.font = fontString(f, sizePx);
    g.textAlign = 'left';
    g.textBaseline = 'alphabetic';
    g.fillStyle = '#000';
    g.fillText('H', Math.round(sizePx * 0.2), baseY);

    var d = g.getImageData(0, 0, w, baseY).data;
    for (var y = 0; y < baseY; y++) {
      for (var x = 0; x < w; x++) {
        if (d[(y * w + x) * 4 + 3] > 128) return baseY - y;
      }
    }
    return null;
  }

  function computeFontSizes() {
    var targetPx = CFG.capHeightMm * pxPerMm;
    for (var i = 0; i < FONTS.length; i++) {
      var f = FONTS[i];
      f.loaded = document.fonts ? document.fonts.check(fontString(f, MEASURE_SIZE)) : true;
      var capRef = measureCapPx(f, MEASURE_SIZE);
      if (!capRef) { f.sizePx = 0; f.sizePt = 0; f.capMm = 0; continue; }
      f.sizePx = targetPx * MEASURE_SIZE / capRef;
      f.sizePt = f.sizePx / pxToPt;
      var drawn = measureCapPx(f, f.sizePx);
      f.capMm = drawn ? drawn / pxPerMm : 0;
    }
    sizesReady = true;
  }

  function fontString(f, sizePx) {
    return f.weight + ' ' + sizePx + 'px "' + f.family + '"';
  }

  function getFont(id) {
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].id === id) return FONTS[i];
    return FONTS[0];
  }

  /* ================================================================
     5) STANJE
     ================================================================ */
  var state = {
    mode: 'text',
    name: '',
    fontId: EASYFLOW.fontValues[EASYFLOW.fontDefault] || 'great-vibes',
    logo: null,
    zoom: false          // pogled od blizu; ne vpliva na to, kar se gravira
  };

  var el, canvas, ctx, layer, lctx, readoutEl, alertEl, zoomBtn;
  var ringImg = new Image();
  var ringReady = false;

  /* ================================================================
     6) BESEDILO PO LOKU
     ----------------------------------------------------------------
     Kot na krogu narašča proti LEVI, zato od začetnega kota
     odštevamo. Če bi to obrnili, bi se ime izpisalo zrcalno.
     ================================================================ */
  function drawTextArc(g) {
    var text = (state.name || '').trim();
    if (!text) return { ok: false, reason: 'empty' };
    if (!sizesReady || !ringReady) return { ok: false, reason: 'loading' };

    var f = getFont(state.fontId);
    var size = f.sizePx;
    if (!size) return { ok: false, reason: 'loading' };

    g.font = fontString(f, size);
    g.textAlign = 'center';
    g.textBaseline = 'alphabetic';

    var chars = Array.prototype.slice.call(text);
    var widths = [], total = 0, i;
    for (i = 0; i < chars.length; i++) {
      var wch = g.measureText(chars[i]).width;
      widths.push(wch);
      total += wch;
    }

    var totalDeg = toDeg(total / GEO.r);
    if (totalDeg > CFG.maxArcSpanDeg) return { ok: false, reason: 'toolong' };

    g.fillStyle = CFG.burnColor;
    g.strokeStyle = CFG.burnColorDeep;
    g.lineWidth = size / 90;            // komaj vidna temnejša obroba
    g.lineJoin = 'round';

    var ang = CFG.arcAngleDeg + totalDeg / 2;
    for (i = 0; i < chars.length; i++) {
      var dDeg = toDeg(widths[i] / GEO.r);
      var mid = ang - dDeg / 2;
      var px = GEO.cx + GEO.r * Math.cos(toRad(mid));
      var py = GEO.cy + GEO.r * Math.sin(toRad(mid));

      g.save();
      g.translate(px, py);
      g.rotate(toRad(mid - 90));        // pri mid = 90 je zasuk 0
      g.strokeText(chars[i], 0, 0);
      g.fillText(chars[i], 0, 0);
      g.restore();

      ang -= dDeg;
    }

    /* mere za xTool — pravi obris črnila, ne škatla pisave */
    var m = g.measureText(text);
    var inkW = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
    var inkH = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;

    return {
      ok: true, kind: 'text',
      wMm: mm(inkW), hMm: mm(inkH),
      totalDeg: totalDeg, sizePt: f.sizePt, fontLabel: f.label, text: text
    };
  }

  /* ================================================================
     7) NALOŽEN PNG
     ================================================================ */
  function drawLogo(g) {
    if (!state.logo) return { ok: false, reason: 'empty' };
    if (!ringReady) return { ok: false, reason: 'loading' };

    var L = state.logo;
    var targetH = CFG.logoHeightMm * pxPerMm;
    var scale = targetH / L.h;
    var dw = L.w * scale, dh = L.h * scale;

    var spanDeg = toDeg(dw / GEO.r);
    if (spanDeg > CFG.maxArcSpanDeg) return { ok: false, reason: 'toowide' };

    var mid = CFG.arcAngleDeg;
    var px = GEO.cx + GEO.r * Math.cos(toRad(mid));
    var py = GEO.cy + GEO.r * Math.sin(toRad(mid));

    g.save();
    g.translate(px, py);
    g.rotate(toRad(mid - 90));
    g.drawImage(L.canvas, -dw / 2, -dh, dw, dh);   // spodnji rob na loku
    g.restore();

    return { ok: true, kind: 'logo', wMm: mm(dw), hMm: mm(dh), totalDeg: spanDeg };
  }

  /* ================================================================
     8) RISANJE
     ================================================================ */
  function drawGuides(g) {
    g.save();
    g.strokeStyle = 'rgba(0,140,255,.85)';
    g.lineWidth = 3;
    g.beginPath();
    g.arc(GEO.cx, GEO.cy, GEO.r, 0, Math.PI * 2);
    g.stroke();
    g.strokeStyle = 'rgba(255,60,60,.7)';
    g.lineWidth = 2;
    g.beginPath();
    g.arc(GEO.cx, GEO.cy, GEO.outerR, 0, Math.PI * 2);
    g.stroke();
    g.beginPath();
    g.moveTo(GEO.cx - 40, GEO.cy); g.lineTo(GEO.cx + 40, GEO.cy);
    g.moveTo(GEO.cx, GEO.cy - 40); g.lineTo(GEO.cx, GEO.cy + 40);
    g.stroke();
    g.restore();
  }

  /* ----------------------------------------------------------------
     POGLED OD BLIZU
     ----------------------------------------------------------------
     Povečava je samo povečevalno steklo — ničesar ne spremeni pri
     tem, kar se bo graviralo. Mere v mm ostanejo iste.
     Ključno za poštenost: povečavo omejimo tako, da v sliki VEDNO
     ostane leseni obroč. Kupec ima s tem ves čas merilo pred očmi
     in velikosti svojega dizajna ne more napačno oceniti.
     ---------------------------------------------------------------- */
  var MAX_ZOOM = 3.2;
  var MIN_ZOOM = 1.5;

  function zoomView(info) {
    if (!state.zoom || !info || !info.ok) return null;

    var contentW = info.wMm * pxPerMm;
    var k = (canvas.width * 0.75) / Math.max(contentW, 1);
    if (k > MAX_ZOOM) k = MAX_ZOOM;
    if (k < MIN_ZOOM) k = MIN_ZOOM;

    var visW = canvas.width / k;
    var visH = canvas.height / k;

    /* sredina gravure: vodoravno sredina kroga, navpično sredina
       med osnovno črto in vrhom gravure                            */
    var midX = GEO.cx;
    var midY = GEO.cy + GEO.r - (info.hMm * pxPerMm) / 2;

    var sx = midX - visW / 2;
    var sy = midY - visH / 2;

    /* izrez ne sme uiti s slike */
    if (sx < 0) sx = 0;
    if (sy < 0) sy = 0;
    if (sx + visW > GEO.w) sx = GEO.w - visW;
    if (sy + visH > GEO.h) sy = GEO.h - visH;

    return { k: k, sx: sx, sy: sy };
  }

  function draw() {
    if (!ctx) return;

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    lctx.clearRect(0, 0, layer.width, layer.height);
    var info = (state.mode === 'text') ? drawTextArc(lctx) : drawLogo(lctx);

    var z = zoomView(info);
    if (z) ctx.setTransform(z.k, 0, 0, z.k, -z.sx * z.k, -z.sy * z.k);

    if (ringReady) ctx.drawImage(ringImg, 0, 0, GEO.w, GEO.h);

    if (info.ok) {
      /* gravura leži samo na lesu — odrežemo vse zunaj fotografije */
      if (ringReady) {
        lctx.save();
        lctx.globalCompositeOperation = 'destination-in';
        lctx.drawImage(ringImg, 0, 0, layer.width, layer.height);
        lctx.restore();
      }
      /* multiply -> skozi gravuro se vidi struktura lesa */
      ctx.save();
      ctx.globalCompositeOperation = 'multiply';
      ctx.globalAlpha = CFG.burnOpacity;
      ctx.drawImage(layer, 0, 0);
      ctx.restore();
    }

    if (DEBUG) drawGuides(ctx);

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    showInfo(info, z);
    updateZoomButton(info);
  }

  /* Gumb za pogled od blizu ima smisel samo, ko je kaj za pokazati. */
  function updateZoomButton(info) {
    if (!zoomBtn) return;
    var can = !!(info && info.ok);
    zoomBtn.hidden = !can;
    if (!can) { state.zoom = false; return; }
    zoomBtn.textContent = state.zoom ? CFG.text.wholeRing : CFG.text.closeUp;
    zoomBtn.setAttribute('aria-pressed', state.zoom ? 'true' : 'false');
  }

  function showInfo(info, z) {
    if (info.ok) {
      var line = (CFG.text.readout || 'Gravura') + ': ' + fmt(info.wMm) + ' × ' + fmt(info.hMm) + ' mm';
      if (info.kind === 'text') line += ' · ' + info.fontLabel + ' ' + fmt(info.sizePt) + ' pt';
      /* Če je vklopljena povečava, to izrecno napišemo — mere v mm
         zgoraj so prava velikost, povečava je samo pogled.        */
      if (z) line += ' · ' + fmt(z.k) + '×';
      readoutEl.textContent = line;
      if (info.kind === 'logo' && state.logo && state.logo.noAlpha) showAlert(CFG.text.bgRemoved || CFG.text.noTransparency, 'warn');
      else hideAlert();
      return;
    }
    readoutEl.textContent = '';
    if (info.reason === 'toolong')      showAlert(CFG.text.tooLong, 'err');
    else if (info.reason === 'toowide') showAlert(CFG.text.tooWide, 'err');
    else                                hideAlert();
  }

  function showAlert(msg, kind) {
    if (!msg) { hideAlert(); return; }
    alertEl.textContent = msg;
    alertEl.className = 'engraving-preview__alert engraving-preview__alert--' + (kind || 'err');
    alertEl.hidden = false;
  }
  function hideAlert() { alertEl.hidden = true; }

  /* ================================================================
     9) NALOŽENA SLIKA -> enobarvna silhueta
     ================================================================ */
  function hexToRgb(hex) {
    var h = hex.replace('#', '');
    return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
  }

  function handleFile(file) {
    hideAlert();
    if (!file) { state.logo = null; refresh(); return; }

    var isPng = (file.type === 'image/png') || /\.png$/i.test(file.name);
    if (!isPng) { state.logo = null; refresh(); showAlert(CFG.text.pngOnly, 'err'); return; }
    if (file.size > CFG.maxUploadMb * 1024 * 1024) {
      state.logo = null; refresh(); showAlert(CFG.text.tooBig, 'err'); return;
    }

    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var res = makeSilhouette(img);
      URL.revokeObjectURL(url);
      if (!res) { showAlert(CFG.text.pngOnly, 'err'); return; }
      state.logo = res;
      if (zoomBtn) state.zoom = true;   /* logotip takoj od blizu (21. 10. 2026) */
      refresh();
      if (res.noAlpha) showAlert(CFG.text.bgRemoved || CFG.text.noTransparency, 'warn');
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      showAlert(CFG.text.pngOnly, 'err');
    };
    img.src = url;
  }

  /* Naložen PNG pretvorimo v to, kar laser res zapeče (21. 10. 2026):
     - prosojno ozadje: temni deli se zapečejo, beli ostanejo les, zato
       napis v krogu ostane viden. Svetel ali enobarven dizajn na
       prosojnem ozadju vzamemo kot obliko (silhueto).
     - brez prosojnega ozadja: barvo ozadja preberemo z robov slike in jo
       odstranimo; zapeče se vse, kar se od ozadja razlikuje.
     Rezultat je enobarven (barva žganja), z mehkim robom, obrezan na dizajn. */
  function makeSilhouette(img) {
    var w0 = img.naturalWidth, h0 = img.naturalHeight;
    if (!w0 || !h0) return null;
    var sc = Math.min(1, 1400 / Math.max(w0, h0));
    var w = Math.max(1, Math.round(w0 * sc)), h = Math.max(1, Math.round(h0 * sc));

    var src = document.createElement('canvas');
    src.width = w; src.height = h;
    var s = src.getContext('2d', { willReadFrequently: true });
    s.drawImage(img, 0, 0, w, h);

    var d;
    try { d = s.getImageData(0, 0, w, h); } catch (e) { return null; }
    var a = d.data, n = w * h, k, i, x, y;
    var L = new Float32Array(n), A = new Float32Array(n), B = new Float32Array(n);
    var opaque = 0;
    for (k = 0, i = 0; k < n; k++, i += 4) {
      A[k] = a[i + 3] / 255;
      L[k] = (0.2126 * a[i] + 0.7152 * a[i + 1] + 0.0722 * a[i + 2]) / 255;
      if (a[i + 3] >= 250) opaque++;
    }
    var noAlpha = opaque / n > 0.98;

    if (!noAlpha) {
      var sum = 0, cnt = 0, lo = 1, hi = 0;
      for (k = 0; k < n; k++) {
        if (A[k] > 0.5) { sum += L[k]; cnt++; if (L[k] < lo) lo = L[k]; if (L[k] > hi) hi = L[k]; }
      }
      if (!cnt || sum / cnt > 0.82 || hi - lo < 0.25) {
        for (k = 0; k < n; k++) B[k] = A[k];                                    // oblika
      } else {
        var top = Math.max(hi, 0.9), span = Math.max(top - lo, 0.001);
        for (k = 0; k < n; k++) B[k] = A[k] * Math.max(0, (top - L[k]) / span); // temno = zapečeno
      }
    } else {
      var bs = 0, bc = 0;
      for (x = 0; x < w; x++) { bs += L[x] + L[(h - 1) * w + x]; bc += 2; }
      for (y = 0; y < h; y++) { bs += L[y * w] + L[y * w + w - 1]; bc += 2; }
      var bg = bs / bc, far = 0.001;
      for (k = 0; k < n; k++) { var dd = Math.abs(L[k] - bg); if (dd > far) far = dd; }
      for (k = 0; k < n; k++) B[k] = Math.abs(L[k] - bg) / far;                // razlika od ozadja
    }

    /* laser žge ali ne žge: skoraj dve stanji, z mehkim robom */
    for (k = 0; k < n; k++) {
      var t = (B[k] - 0.28) / 0.34;
      B[k] = t <= 0 ? 0 : (t >= 1 ? 1 : t * t * (3 - 2 * t));
    }

    var rgb = hexToRgb(CFG.burnColor);
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        k = y * w + x; i = k * 4;
        a[i] = rgb[0]; a[i + 1] = rgb[1]; a[i + 2] = rgb[2];
        a[i + 3] = Math.round(B[k] * 255);
        if (B[k] > 0.08) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    s.putImageData(d, 0, 0);

    var cw = maxX - minX + 1, ch = maxY - minY + 1;
    var out = document.createElement('canvas');
    out.width = cw; out.height = ch;
    out.getContext('2d').drawImage(src, minX, minY, cw, ch, 0, 0, cw, ch);

    return { canvas: out, w: cw, h: ch, noAlpha: noAlpha };
  }

  /* ================================================================
     10) ISKANJE POLJ EASYFLOW
     ================================================================ */
  function findFontSelect(root) {
    var sels = root.querySelectorAll('select');
    var known = Object.keys(EASYFLOW.fontValues);
    var i, j;
    /* glavna pot: prepoznamo ga po vrednostih v seznamu */
    for (i = 0; i < sels.length; i++) {
      var vals = [];
      for (j = 0; j < sels[i].options.length; j++) vals.push(sels[i].options[j].value);
      var hits = 0;
      for (j = 0; j < known.length; j++) if (vals.indexOf(known[j]) !== -1) hits++;
      if (hits >= 2) return sels[i];
    }
    /* rezervna pot: po besedilu oznake */
    for (i = 0; i < sels.length; i++) {
      var box = sels[i].closest ? sels[i].closest('.ef__product-option') : null;
      if (box && box.textContent.indexOf(EASYFLOW.fontFieldLabel) !== -1) return sels[i];
    }
    return null;
  }

  function findNameInput(root) {
    var el = root.querySelector('input[type="text"][name="' + EASYFLOW.nameFieldName + '"]');
    if (el) return el;
    var texts = root.querySelectorAll('input[type="text"]');
    for (var i = 0; i < texts.length; i++) {
      if (texts[i].getAttribute('maxlength')) return texts[i];
    }
    return null;
  }

  function findFileInput(root) {
    return root.querySelector('input[type="file"][name="' + EASYFLOW.fileFieldName + '"]')
        || root.querySelector('input[type="file"]');
  }

  /* Polja iščemo VSAKIČ znova, nikoli si jih ne zapomnimo za stalno.
     EasyFlow polja skrije in znova pokaže glede na to, ali kupec
     nalaga svoj dizajn — pri tem jih lahko odstrani iz strani in
     ustvari na novo. Stara referenca bi takrat kazala v prazno.     */
  var fields = { name: null, font: null, file: null };

  function resolveFields() {
    var root = document.querySelector(EASYFLOW.rootSelector);
    if (!root) {
      fields = { name: null, font: null, file: null };
      return false;
    }
    fields.name = findNameInput(root);
    fields.font = findFontSelect(root);
    fields.file = findFileInput(root);
    return !!(fields.name || fields.font || fields.file);
  }

  /* Ali kupec res vidi polje. Strogo — za ime in pisavo.
     Če EasyFlow polje skrije, mora tu priti false.                  */
  function isVisible(el) {
    return !!(el && el.isConnected && el.offsetParent !== null);
  }

  /* Za polje z datoteko velja ohlapneje: aplikacije pravo polje
     pogosto vizualno skrijejo in namesto njega pokažejo svoj gumb
     ("Choose file"). Zato šteje tudi, če je viden samo vsebnik.     */
  function isFileActive(el) {
    if (!el || !el.isConnected) return false;
    if (el.offsetParent !== null) return true;
    var box = (el.closest && el.closest('.ef__product-option')) || el.parentElement;
    return !!(box && box.offsetParent !== null);
  }

  /* Kateri način pokazati.
     Ime skrito + nalaganje vidno  -> kupec nalaga svoj dizajn.
     Nalaganje skrito              -> datoteka ni več del naročila. */
  function decideMode() {
    var nameAlive = isVisible(fields.name);
    var fileAlive = isFileActive(fields.file);
    if (!fileAlive) state.logo = null;
    if (state.logo) return 'logo';
    if (!nameAlive && fileAlive) return 'logo';
    return 'text';
  }

  function waitForEasyflow(cb) {
    var t0 = Date.now();
    (function tick() {
      var root = document.querySelector(EASYFLOW.rootSelector);
      if (root && resolveFields() && (fields.name || fields.font)) { cb(root); return; }
      if (Date.now() - t0 > EASYFLOW.waitMs) return;   // tiho odnehamo
      setTimeout(tick, 200);
    })();
  }

  /* ================================================================
     11) GUMBI S PRIMERI
     ----------------------------------------------------------------
     Edino mesto, kjer pišemo v polje EasyFlow. Vrednost nastavimo
     prek izvornega setterja, sicer je aplikacije, zgrajene na
     Reactu, ne opazijo.
     ================================================================ */
  function setNativeValue(input, value) {
    var proto = Object.getPrototypeOf(input);
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) desc.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ================================================================
     12) ZAGON
     ================================================================ */
  function boot() {
    el = document.querySelector('[data-engraving-preview]');
    if (!el) return;

    canvas = el.querySelector('[data-engraving-canvas]');
    readoutEl = el.querySelector('[data-engraving-readout]');
    alertEl = el.querySelector('[data-engraving-alert]');
    zoomBtn = el.querySelector('[data-engraving-zoom]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        state.zoom = !state.zoom;
        draw();
      });
    }
    if (!canvas || !readoutEl || !alertEl) return;

    ctx = canvas.getContext('2d');
    layer = document.createElement('canvas');
    lctx = layer.getContext('2d');

    var probe = 'HMarkoŠŽČ';
    var jobs = FONTS.map(function (f) {
      return document.fonts
        ? document.fonts.load(f.weight + ' 100px "' + f.family + '"', probe)
        : Promise.resolve();
    });
    var fontsDone = Promise.all(jobs)['catch'](function () { /* pisave niso pogoj za zagon */ });

    var imageDone = new Promise(function (res) {
      ringImg.onload = function () { ringReady = true; res(true); };
      ringImg.onerror = function () { res(false); };
      ringImg.src = CFG.ringImage;
    });

    var readyToDraw = Promise.all([fontsDone, imageDone]).then(function () {
      var w = ringImg.naturalWidth || 1200;
      var h = ringImg.naturalHeight || 800;
      canvas.width = w; canvas.height = h;
      layer.width = w; layer.height = h;
      computeGeometry(w, h);
      computeFontSizes();
      if (DEBUG) logDebug();
    });

    /* Predogled je v HTML skrit. Najprej ga prestavimo nad polja
       EasyFlow in ga šele nato pokažemo — brez utripanja.          */
    waitForEasyflow(function (root) {
      ensurePlacement();

      readyToDraw.then(function () {
        if (!ringReady) return;          // brez fotografije ne kažemo nič
        attachDelegation();
        startObserver(root);
        bindExampleButtons();
        readState();
        draw();
        el.hidden = false;
      });
    });
  }

  /* ----------------------------------------------------------------
     Poslušamo na dokumentu, ne na posameznih poljih.
     Če EasyFlow polje odstrani in ustvari na novo, bi se poslušalec,
     pripet na stari element, izgubil. Dogodka input in change se
     dvigujeta do dokumenta, zato jih ujamemo tam — in to v fazi
     zajemanja, da nas ne prehiti morebitno ustavljanje dogodka.
     ---------------------------------------------------------------- */
  function attachDelegation() {
    document.addEventListener('input', onFieldEvent, true);
    document.addEventListener('change', onFieldEvent, true);
    document.addEventListener('focusin', onFieldFocus, true);
  }

  /* Telefon: ko kupec klikne v polje za ime ali pisavo, stran pomaknemo
     tako, da je predogled na vrhu, polje pa tik pod njim. Tako med
     tipkanjem vidi ime na krogu. Na računalniku ne naredimo nič.     */
  function onFieldFocus(ev) {
    var t = ev.target;
    if (!t || !t.closest || !t.closest(EASYFLOW.rootSelector)) return;
    if (t.tagName !== 'SELECT' && t.type !== 'text') return;
    if (window.innerWidth > 768 || !el || el.hidden) return;
    setTimeout(function () {
      var off = 8;
      var hdr = document.querySelector('.site-header');
      if (hdr) {
        var hb = hdr.getBoundingClientRect();
        if (hb.top <= 1 && hb.bottom > 0) off += hb.bottom;
      }
      var top = el.getBoundingClientRect().top + window.pageYOffset - off;
      if (Math.abs(window.pageYOffset - top) > 12) window.scrollTo({ top: top, behavior: 'smooth' });
    }, 350);
  }

  function onFieldEvent(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (!t.closest(EASYFLOW.rootSelector)) return;   // ni polje EasyFlow

    /* element je morda nov -> reference osvežimo, preden primerjamo */
    if (t !== fields.name && t !== fields.font && t !== fields.file) resolveFields();

    if (t === fields.file) {
      handleFile(t.files && t.files[0]);
      return;
    }
    refresh();
  }

  /* Nadzor nad stranjo: EasyFlow polja skriva, prikazuje in lahko
     zamenja cel blok. Ob vsaki taki spremembi znova poiščemo polja,
     poskrbimo, da predogled še vedno stoji nad njimi, in prerišemo. */
  var observer = null;

  function startObserver(root) {
    var block = root.closest('.shopify-app-block') || root;
    var scope = block.parentNode;
    if (!scope || typeof MutationObserver === 'undefined') return;

    var pending = false;
    observer = new MutationObserver(function (muts) {
      /* spremembe v samem predogledu (mere, opozorila, gumb) ne štejejo,
         sicer se predogled v neskončnost riše znova (21. 10. 2026) */
      var own = true;
      for (var m = 0; m < muts.length; m++) {
        if (!el || !el.contains(muts[m].target)) { own = false; break; }
      }
      if (own || pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        resolveFields();
        ensurePlacement();
        refresh();
      }, 120);
    });
    observer.observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  /* Predogled mora stati tik nad blokom EasyFlow. Če ga aplikacija
     zamenja, se lahko znajde na napačnem mestu — takrat ga vrnemo.  */
  function ensurePlacement() {
    var root = document.querySelector(EASYFLOW.rootSelector);
    if (!root || !el) return;
    var block = root.closest('.shopify-app-block') || root;
    if (!block.parentNode) return;
    if (el.nextElementSibling === block) return;      // že na mestu
    block.parentNode.insertBefore(el, block);
  }

  function refresh() {
    readState();
    draw();
    /* Če EasyFlow polja skrije, predogled ne izgine — pokaže zadnje
       veljavno stanje. Skrijemo ga samo, če izgine cel blok.        */
    el.hidden = !document.querySelector(EASYFLOW.rootSelector);
  }

  function bindExampleButtons() {
    var buttons = el.querySelectorAll('[data-engraving-example]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (ev) {
        var value = ev.currentTarget.getAttribute('data-engraving-example');
        resolveFields();
        if (!fields.name || !fields.name.isConnected) return;   // ni kam pisati
        setNativeValue(fields.name, value);
        refresh();
      });
    }
    /* gumbi s primeri nimajo smisla, dokler ni polja za ime */
    updateExamplesVisibility();
  }

  function updateExamplesVisibility() {
    var box = el.querySelector('[data-engraving-examples]');
    if (box) box.hidden = !isVisible(fields.name);
  }

  function readState() {
    /* Beremo samo, kar je še v strani. Skrito polje še vedno beremo —
       njegova vrednost gre v naročilo. Odstranjeno polje pustimo pri
       zadnji znani vrednosti, da predogled ne skoči v prazno.        */
    if (fields.name && fields.name.isConnected) {
      state.name = (fields.name.value || '').slice(0, CFG.maxChars);
    }
    if (fields.font && fields.font.isConnected) {
      var id = EASYFLOW.fontValues[fields.font.value];
      if (id) state.fontId = id;      // prazna izbira -> obdržimo zadnjo
    }
    state.mode = decideMode();
    updateExamplesVisibility();
  }

  function logDebug() {
    /* samo pri ?debug=1 */
    console.log('%c[gravura] kontrolne vrednosti', 'font-weight:bold');
    console.table({
      'slika (px)': GEO.w + ' x ' + GEO.h,
      'pxPerMm': +pxPerMm.toFixed(4),
      'premer kroga (mm)': +(2 * GEO.outerR / pxPerMm).toFixed(1),
      'polmer gravure (mm)': +(GEO.r / pxPerMm).toFixed(2)
    });
    var rows = {};
    FONTS.forEach(function (f) {
      rows[f.label] = {
        'px': +f.sizePx.toFixed(2),
        'pt -> xTool': +f.sizePt.toFixed(1),
        'visina H (mm)': +f.capMm.toFixed(2),
        'nalozena': f.loaded ? 'da' : 'NE'
      };
    });
    console.table(rows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
